/* @flow */

import React from 'react';
import { compose, withState } from 'recompose';
import cx from 'classnames';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import _ from 'lodash';

// import classes from './SaveDesignModal.scss';

// const log = require('bows')('SaveDesignModal');

type PropsType = {
  name: string,
  onHide: Function,
  onSubmit: Function,
  setName: Function,
  show: boolean,
};
// type StateType = {};

export class SaveDesignModal extends React.PureComponent<PropsType, *> {
  static defaultProps = {};

  // state: StateType; // eslint-disable-line react/sort-comp
  props: PropsType; // eslint-disable-line react/sort-comp

  /*
  constructor(props: PropsType) {
    super(props);
  }
  */

  render() {
    const toggle = this.props.onHide;
    const isValid = this.props.name.length > 0;
    const submit = this.props.onSubmit;

    const submitHandler = (e: InputEvent) => {
      e.preventDefault();
      submit(this.props.name);
      toggle();
    };

    const handleOnChange = (e: InputEvent) => {
      this.props.setName(e.target.value);
    };

    return (
      <Modal isOpen={this.props.show} toggle={toggle}>
        <ModalHeader toggle={toggle}>Save Design</ModalHeader>
        <ModalBody className="row">
          <div className="col-sm-12">
            <fieldset className={cx('form-group', { 'has-danger': !isValid })}>
              <input
                type="text"
                onChange={handleOnChange}
                className={cx('form-control', { 'form-control-danger': !isValid })}
                placeholder="Design Name"
                value={this.props.name}
              />
              {!isValid &&
                <div
                  className="text-muted form-control-feedback"
                  style={{ paddingLeft: 0, paddingTop: '8px' }}
                >Design name is required.</div>
              }
            </fieldset>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" id="submit" type="submit" onClick={submitHandler} disabled={!isValid}>Save</Button>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const enhancer = compose(
  withState('name', 'setName', (props: PropsType): string => {
    const name = _.get(props, ['initialName'], '');
    return name === 'Untitled Design' ? '' : name;
  }),
);

export default enhancer(SaveDesignModal);



// WEBPACK FOOTER //
// ./src/components/SaveDesignModal/SaveDesignModal.js